export default __webpack_public_path__ + "static/media/car-parking.ac0bd5bc.png";